// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteOrganization_container__UeZXm {
  padding: 1rem;
  background-color: white;
  border-radius: 8px;
  min-width: 350px;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.DeleteOrganization_header__ugzW3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DeleteOrganization_header__ugzW3 h4 {
  margin: 0;
}

.DeleteOrganization_header__ugzW3 span {
  cursor: pointer;
}

.DeleteOrganization_orgName__KjRYq {
  color: #3082f6;
  font-weight: 800;
}

.DeleteOrganization_container__UeZXm p {
  margin: 0;
  color: rgba(27, 31, 59, 0.65);
}

.DeleteOrganization_buttons__ltGoa {
  display: flex;
  width: 100%;
  gap: 16px;
}

.DeleteOrganization_cancelBtn__MptTJ {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: 1px solid #a4a5b1;
  background-color: transparent;
  cursor: pointer;
  color: #676c7e;
}

.DeleteOrganization_confirmBtn__uVCuC {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: none;
  background-color: #3082f6;
  color: white;
  cursor: pointer;
}

.DeleteOrganization_confirmBtn__uVCuC:disabled {
  background-color: #8cb6f1;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/deleteOrganization/DeleteOrganization.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  padding: 1rem;\n  background-color: white;\n  border-radius: 8px;\n  min-width: 350px;\n  max-width: 450px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h4 {\n  margin: 0;\n}\n\n.header span {\n  cursor: pointer;\n}\n\n.orgName {\n  color: #3082f6;\n  font-weight: 800;\n}\n\n.container p {\n  margin: 0;\n  color: rgba(27, 31, 59, 0.65);\n}\n\n.buttons {\n  display: flex;\n  width: 100%;\n  gap: 16px;\n}\n\n.cancelBtn {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0 16px;\n  border: 1px solid #a4a5b1;\n  background-color: transparent;\n  cursor: pointer;\n  color: #676c7e;\n}\n\n.confirmBtn {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0 16px;\n  border: none;\n  background-color: #3082f6;\n  color: white;\n  cursor: pointer;\n}\n\n.confirmBtn:disabled {\n  background-color: #8cb6f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeleteOrganization_container__UeZXm`,
	"header": `DeleteOrganization_header__ugzW3`,
	"orgName": `DeleteOrganization_orgName__KjRYq`,
	"buttons": `DeleteOrganization_buttons__ltGoa`,
	"cancelBtn": `DeleteOrganization_cancelBtn__MptTJ`,
	"confirmBtn": `DeleteOrganization_confirmBtn__uVCuC`
};
export default ___CSS_LOADER_EXPORT___;
